import React from "react";
import { Button } from "devextreme-react";

// Props
interface PendingRemovalComponentProps {
    onRemovalClick: (event: any) => void;
    buttonText: string;
    isDisabled: boolean;
    currentRowState: {
        id: string;
        fileFormatTypeLookUpId: string;
        fileFormatText: string;
        fileTypeText: string;
        fileName: string;
        serviceTypeId: string;
        serviceType: string;
        serviceSubTypeId: string;
        serviceSubType: string;
        status: string;
        errorMessage: string;
        lastUpdatedOn: string;
        lastUpdatedBy: string;
    };
}

// State
interface PendingRemovalComponentState {}

// Component - Submit button that changes state based on status
class PendingRemovalComponent extends React.Component<PendingRemovalComponentProps> {
    render() {
        return (
            <Button
                className="btn btn-primary mr-3 btn--fixed-large"
                disabled={this.props.isDisabled}
                onClick={this.props.onRemovalClick}
                text={this.props.buttonText}
                type="normal"
            />
        );
    }
}

export default PendingRemovalComponent;
